var messages = {
  cancelText: '取消',
  justOkText: '确定',
  okText: '确定',
  rejectText: '否定'
};
export default messages;